const comments = [
  {
    avatar: '吃',
    name: '吃瓜专业户',
    time: '2小时前',
    text: '这个瓜我吃了三天了，每天都有新进展，太刺激了！比追剧还上头。',
    tag: '铁粉',
  },
  {
    avatar: '理',
    name: '理性吃瓜人',
    time: '5小时前',
    text: '每日大瓜的深扒文章真的细，连时间线都理得清清楚楚，比营销号靠谱一百倍。',
    tag: '资深瓜友',
  },
  {
    avatar: '自',
    name: '自由言论者',
    time: '8小时前',
    text: '终于找到一个不删帖、不控评的真瓜平台了，这里说真话不会被捂嘴。',
  },
  {
    avatar: '资',
    name: '资深瓜农',
    time: '12小时前',
    text: '从塌房到连环瓜，这个站捋得比营销号清楚一万倍，逻辑闭环绝了。',
    tag: '年度瓜王',
  },
  {
    avatar: '摸',
    name: '摸鱼达人',
    time: '1天前',
    text: '每天上班第一件事就是刷每日大瓜，比咖啡还提神，根本停不下来。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">瓜友热评</h2>
          <p className="mt-2 text-sm text-foreground-500">看看吃瓜群众怎么说</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold font-heading flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</span>
                    {comment.tag && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        {comment.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}